module.exports = __webpack_public_path__ + "img/pipei.2ef896e.png";